import { Inject, Injectable, Optional } from '@angular/core';

import { ITypeBetslip } from '../../../../../bet-generation/models';
import { BetslipError } from '../../../../errors/betslip-error';
import { PURE_TYPE_BETSLIP_VALIDATORS } from '../../../betslip-validation-injection-tokens';
import { IPureTypeBetslipValidator } from '../../../validators/type/validators';

@Injectable()
export class BetslipTypePureValidationComposerService {
    constructor(@Optional() @Inject(PURE_TYPE_BETSLIP_VALIDATORS) private validators?: IPureTypeBetslipValidator<BetslipError>[]) {}

    validate(typeBetslip: ITypeBetslip): BetslipError[] {
        return this.validators?.flatMap((validator) => Array.from(validator.validate(typeBetslip))) ?? [];
    }
}
